import { Component, ViewEncapsulation, Input, Output, EventEmitter, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ControlType } from '@app/cp/shared/enums/ControlTypes';
import { GItem } from '@app/cp/shared/models/GItem';
import { UseFeatureFlagSet, IFeatureFlagSet } from '../../decorators/featureflags/featureflagset-decorator';
import { CommonParam } from '../../models/CommonParam';

import { GenericSelector, GenericSearch, ContractSearch, QuoteSearch, OrderSearch, InvoiceSearch, PartsHistorySearch, PartsMergeSearch, PartsCostHistorySearch, InvoiceActionSearch, CycleCountingHistorySearch } from '../../models/GenericSelector';
import { GenericSelectorComponent } from '../generic-selector/generic-selector.component';
import { GlobalsService } from '../../services/globals.service';
//import { DatePickerComponent } from 'ngx-bootstrap';

@UseFeatureFlagSet()
@Component({
    selector: 'generic-search',
    templateUrl: './generic-search.component.html',
    styleUrls: ['./generic-search.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GenericSearchComponent  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    @ViewChildren('genSelComp') genSelComps: QueryList<GenericSelectorComponent>;
    //@ViewChildren('datePickerComp')  datePickerComps: QueryList<DatePickerComponent>;
    @ViewChildren('inputTextEl') inputTextEls: QueryList<ElementRef>;
    @Input() SearchCode: string;
    @Input() SearchParams: CommonParam;
    @Output() Search: EventEmitter<any> = new EventEmitter<any>();
    @Output() Cancel: EventEmitter<any> = new EventEmitter<any>();
    data: GItem[];
    searchFields: GenericSelector[]
    @Input() SearchDef: GenericSearch;
    //public ControlTypeEnum = ControlType;
    get ControlTypeEnum() { return ControlType; }
    constructor(private _globalsService: GlobalsService) {
    }
    ngOnInit() {
        let searchCode = this.SearchCode.toUpperCase();
        switch (searchCode) {
            case "CP_CONTRACTS":
                this.SearchDef = new ContractSearch();
                break;
            case "CP_JOBS":
                this.SearchDef = new ContractSearch();
                break;
            case "CP_DISPATCHES":
                this.SearchDef = new ContractSearch();
                break;
            case "CP_QUOTES":
                this.SearchDef = new QuoteSearch();
                break;
            case "CP_ORDERS":
                this.SearchDef = new OrderSearch();
                break;
            case "CP_INVOICES":
                this.SearchDef = new InvoiceSearch();
                break;
            case "CP_PARTSHISTORY":
                this.SearchDef = new PartsHistorySearch(this._globalsService);
                //this.SearchDef.showCloseButton
                //this.SearchDef.searchTitle
                break;
            case "CP_PARTSCOSTHISTORY":
                this.SearchDef = new PartsCostHistorySearch();
                //this.SearchDef.showCloseButton
                //this.SearchDef.searchTitle
                break;
            case "CP_PARTSMERGE":
                this.SearchDef = new PartsMergeSearch();

                break;
            case "CP_CYCLECOUNTINGHISTORY":
                this.SearchDef = new CycleCountingHistorySearch();

                break;
            case "CP_INVOICEACTION":
                this.SearchDef = new InvoiceActionSearch();
                //this.SearchDef.showCloseButton
                //this.SearchDef.searchTitle
                break;

        }
        //this.searchFields = [
        //    { searchCode: 'division', controlType: ControlType.genericSelector, caption: 'Division', dataFieldName: 'divisionId', controlId: 0, sortOrder: 0, value: null, placeHolder: 'Search Divisions...', serviceType: 2, active: true, minSearchSize: 1 },
        //    { searchCode: 'customer', controlType: ControlType.genericSelector, caption: 'Customer', dataFieldName: 'customerId', controlId: 1, sortOrder: 1, value: null, placeHolder: 'Search Customer...', serviceType: 2, active: true, minSearchSize: 3 },
        //    { searchCode: 'location', controlType: ControlType.genericSelector, caption: 'Location', dataFieldName: 'locationId', controlId: 2, sortOrder: 2, value: null, placeHolder: 'Search Location...', serviceType: 2, active: true, minSearchSize: 3  },
        //    { searchCode: 'accountClass', controlType: ControlType.genericSelector, caption: 'Class', dataFieldName: 'accountClassId', controlId: 3, sortOrder: 3, value: null, placeHolder: 'Search Class...', serviceType: 2, active: true, minSearchSize: 1  },
        //    { searchCode: 'dispatchStatus', controlType: ControlType.genericSelector, caption: 'Status', dataFieldName: 'dispatchStatusId', controlId: 4, sortOrder: 4, value: null, placeHolder: 'Search Status...', serviceType: 2, active: true, minSearchSize: 1  },
        //    { searchCode: 'person', controlType: ControlType.genericSelector, caption: 'CreatedBy', dataFieldName: 'personId', controlId: 5, sortOrder: 5, value: null, placeHolder: 'Search Created By...', serviceType: 2, active: true, minSearchSize: 3 },
        //    { searchCode: 'startDate', controlType: ControlType.datePicker, caption: 'Start Date', dataFieldName: 'startDate', controlId: 6, sortOrder: 6, value: null, placeHolder: '', serviceType: 2, active: true, minSearchSize: null  },
        //    { searchCode: 'endDate', controlType: ControlType.datePicker, caption: 'End Date', dataFieldName: 'endDate', controlId: 7, sortOrder: 7, value: null, placeHolder: '', serviceType: 2, active: true, minSearchSize: null   },
        //    { searchCode: 'reason', controlType: ControlType.textBox, caption: 'Reason Search', dataFieldName: 'dispatchReason', controlId: 8, sortOrder: 8, value: null, placeHolder: 'Search Reason...', serviceType: 2, active: true, minSearchSize: null }
        //]
     //   this.SearchParams.addParam("MasterSearchCode", this.SearchCode);
    }
    getParameter(): CommonParam {
        let param: CommonParam = this.SearchParams; // new CommonParam();
        //if (!param) {
        //    param = new CommonParam();
        //}
 //       param.active = this.IsActive;
        param.addParam("SearchCode", this.SearchCode);
        //        param.addParam("SearchParams", this.SearchParams);
        return param;
    }
    genericSelector_Selected(valueName: string, value: any) {
        if (valueName === "customerId") {
            this.SearchParams.customerId = value.value;
        }
        else if (valueName === "locationId") {
            this.SearchParams.locationId = value.value;
        }
        else {
            this.SearchParams.addParam(valueName, value.value);
        }
        this.SearchDef.setField(valueName, value.value, value.description);

    }
    date_Selected(valueName: string, value: any) {
        if (valueName === "startDate") {
            this.SearchParams.startDate = value;
        }
        else if (valueName === "endDate") {
            this.SearchParams.endDate = value;
        }
        else {
            this.SearchParams.addParam(valueName, value);
        }
        this.SearchDef.setField(valueName, value);
    }
    onBlur_text(valueName: string, value: any) {
        this.SearchParams.addParam(valueName, value);

    }
    doSearch() {
        let param: CommonParam = this.getParameter();
        this.Search.emit(param);
    }
    cancel() {
        this.Cancel.emit(null);
    }
    clear()
    {
        for (var comp of this.genSelComps.toArray()) {
            comp.clear();
        }
        /*for (var datePicker of this.datePickerComps.toArray()) {
            //datePicker.activeDate = new Date();
            datePicker.writeValue(null);
        }*/
        for (var inputText of this.inputTextEls.toArray()) {
            //datePicker.activeDate = new Date();
            inputText.nativeElement.value = "";
        }
        if (this.SearchParams) {
            this.SearchParams.clearCustom();
        }
        this.SearchDef.clearValues();
//        this.cd.detectChanges();
    }
}
